module.exports = __webpack_public_path__ + "img/journal_blue_250px.c4c8d0b7.svg";